import React from "react";

import styles from "./MeetTheTeamComponent.module.css";
const CreditsComponent = () => {
  return (
    <section className={`${styles.team_container} fixed-nav`}>
      <div className={styles.team_container_bg}></div>
      <div className={styles.meet_team_container_icon1}></div>
      <div className={styles.meet_team_container_icon2}></div>
      <div className="container-fluid">
        <div className={styles.team_heading}>
          <h1>Thank You!</h1>
          <p className={styles.team_heading}>
            Starlight Music would like to thank all of these amazing vendors who
            have provided content or partnered with us to create the materials
            used on this website. We greatly appreciate collaborating with you
            and look forward to many more unforgettable events together.
          </p>
        </div>
        <div className={`row justify-content-center ${styles.links}`}>
          <div className={` col-lg-6 col-md-12`}>
            <a
              href="https://melanilustphotography.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Melani Lust Photography</p>
            </a>
            <a href="https://guastavinos.com/" target="_blank" rel="noreferrer">
              <p className={styles.link}>Guastavino’s</p>
            </a>
            <a
              href="https://www.seofusion.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>SEO Fusion</p>
            </a>
            <a
              href="https://www.globalavgroup.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Global AV Group</p>
            </a>
            <a
              href="https://davegiordano.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Dave Giordano</p>
            </a>
            <a
              href="https://www.roeyyohaistudios.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Li Roey Yohai Studiosnk</p>
            </a>
            <a href="https://kpmediany.com/" target="_blank" rel="noreferrer">
              <p className={styles.link}> KP Media</p>
            </a>
            <a
              href="https://www.sarahmerians.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Sara Merians</p>
            </a>
            <a
              href="http://nathanramirezphotography.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Nathan Ramirez Photography</p>
            </a>
            <a href="#" target="_blank" rel="noreferrer">
              <p className={styles.link}>Ejai Jiminez Photography</p>
            </a>
            <a
              href="http://brianhattonweddings.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Brian Hatton Photography</p>
            </a>
            <a
              href="https://rachelrowland.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Rachel Rowland Photography</p>
            </a>

            <a
              href="https://louisvillephotographer.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Ryan Armbrust Photography</p>
            </a>
            <a
              href="https://suzannedelawar.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Suzanne Delawar Studios</p>
            </a>

            <a
              href="https://michaelromeocreations.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Michael Romeo Creations</p>
            </a>
            <a
              href="https://www.anerinooriginals.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Anerino Originals</p>
            </a>
            <a
              href="https://www.fredmarcus.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Fred Marcus Studio</p>
            </a>
            <a
              href="https://www.laurenlarsen.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Lauren Larsen Studio</p>
            </a>
            <a
              href="https://www.blainesiesser.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Blaine Siesser Photography </p>
            </a>
            <a
              href="https://www.briandorseystudios.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Brian Dorsey Studios</p>
            </a>
            <a
              href="https://philipgabriel.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Philip Gabriel Photography</p>
            </a>
            <a href="https://www.abbyjiu.com/" target="_blank" rel="noreferrer">
              <p className={styles.link}> Abby Jiu Photography</p>
            </a>
            <a
              href="https://www.vanessajoy.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}> Vanessa Joy Photography </p>
            </a>
            <a
              href="https://www.irarosenstudio.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Ira Rosen Studio </p>
            </a>
            <a
              href="https://www.instagram.com/cherylemakeup/"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.link}>Cheryl.e Makeup</p>
            </a>
          </div>
        </div>
        <div className={styles.team_heading}>
          <p className={styles.team_heading}>
            If you have contributed content but are not listed here, please
            contact the office. We will gladly add your information.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CreditsComponent;
